import type { FavouriteProduct, FavouriteProductLocation } from './favouriteTypes'
import type { GA4AnalyticsEvent } from '@/domain/shared/types'
import { createFavoriteClickedEvent } from '@/scopes/search/search/domain/analytics'

const FAVORITES_LIST_NAME = 'favorites'

export function createFavoriteImpressionViewEvent(products: FavouriteProduct[]): GA4AnalyticsEvent {
  return {
    event: 'eec.impressionView',
    ecommerce: {
      impressions: products.map((product, index) => ({
        id: product.id,
        name: product.name,
        category: '',
        position: index + 1,
        accoStars: product.rating,
        badges: '',
        rating: product.userRating ?? 0,
        entryPrice: 0,
        campaignId: '',
        campaignName: '',
        cityId: '',
        countryId: '',
        regionId: '',
        list: FAVORITES_LIST_NAME,
        duration: '',
        totalGuests: 0,
        departureDate: '',
      })),
    },
  }
}

export function createFavoriteRemovalEvent(product: FavouriteProduct): GA4AnalyticsEvent {
  const locations = getLocationNames(product.locations)

  return createFavoriteClickedEvent({
    id: product.id,
    name: product.name,
    cityId: '',
    countryId: '',
    regionId: '',
    cityName: locations.city,
    countryName: locations.country,
    regionName: locations.region,
    cityEnglishName: locations.city,
    countryEnglishName: locations.country,
    regionEnglishName: locations.region,
    rating: product.rating,
    userRating: product.userRating ?? 0,
    origin: FAVORITES_LIST_NAME,
    actionResult: 'not_marked_as_favorite',
  })
}

function getLocationNames(locations: FavouriteProductLocation[]) {
  return {
    city: locations.find(location => location.type === 'city')?.name ?? '',
    country: locations.find(location => location.type === 'country')?.name ?? '',
    region: locations.find(location => location.type === 'region')?.name ?? '',
  }
}
